import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

import { func_validation, func_cookieSetting, func_datetime } from 'functions';

export const clientRegistrationColumns = {
    // Columns Array
    getColumns,

    // Columns
    getColumns_companyID,
    getColumns_companyName,
    getColumns_email,
    getColumns_status,
    getColumns_isSuspended,
}

function getColumns() {
    return [
        getColumns_companyID(),
        getColumns_companyName(),
        getColumns_email(),
        getColumns_status(),
        getColumns_isSuspended(),
    ];
}

function getColumns_companyID() {
    let columnClassName = "distributorPortal-clientRegistration-tableColumn-companyID";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Com ID",
        id: "companyID",
        accessor: "comId",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_companyName() {
    let columnClassName = "distributorPortal-clientRegistration-tableColumn-companyName";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Company Name",
        id: "companyName",
        accessor: "comName",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_email() {
    let columnClassName = "distributorPortal-clientRegistration-tableColumn-email";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Email",
        id: "email",
        accessor: "Email",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_status() {
    let columnClassName = "distributorPortal-clientRegistration-tableColumn-status";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Status",
        // isHeaderColumnSortable: true,
        // sortValue: "status"
        id: "isTrial",
        accessor: "Trial",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let isTrial = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = isTrial? "Trial": "Active";

            // Status Color
            let statusIconColor = isTrial? "distributorPortal-clientRegistration-columnStatus-icon_pending": "distributorPortal-clientRegistration-columnStatus-icon_success";
            // switch (value_formatted) {
            //     case "Sent":
            //         statusIconColor = "distributorPortal-clientRegistration-columnStatus-icon_success";
            //         break;
            //     case "Incomplete":
            //         statusIconColor = "distributorPortal-clientRegistration-columnStatus-icon_failure";
            //         break;
            //     default:
            //         break;
            // }

            return (
                <div className={"distributorPortal-clientRegistration-table-statusCell noWrap-text-ellipsis"}>
                    {func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")? 
                        (<FontAwesomeIcon 
                            className={"distributorPortal-clientRegistration-statusCell-icon " + statusIconColor} 
                            icon={faCircle}
                        />
                    ):""}
                    <span>{value_formatted}</span>
                </div>
            );
        },
    }
}

function getColumns_isSuspended() {
    let columnClassName = "distributorPortal-clientRegistration-tableColumn-is-suspended";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Suspended",
        id: "isSuspended",
        accessor: "Suspended",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}
